import apiService from "./apiServices";

export const getCustomerListServices = async (token, formData, page, size) => {
  try {
    const response = await apiService(`/client-customers/search?page=${page}&size=${size}&sort=desc`, 'POST', token, null, formData);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to customer search. Please try again.');
  }
};


export const getCustomerDataServices = async (token, id, page, size) => {
  try {
    const response = await apiService(`/policy/client-customer/${id}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to customer data. Please try again.');
  }
};

export const getQuoteListServices = async (token, clientCustomerId,  page, size) => {
  try {
    const response = await apiService(`/quoteslist/client-customer/${clientCustomerId}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to customer data. Please try again.');
  }
};

export const getTaskListServices = async (token, clientCustomerId,  page, size) => {
  try {
    const response = await apiService(`/addtask/client-customer/${clientCustomerId}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to customer data. Please try again.');
  }
};

export const getNotesListServices = async (token, clientCustomerId,  page, size) => {
  try {
    const response = await apiService(`/notes/client-customer/${clientCustomerId}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to customer data. Please try again.');
  }
};

export const getActivityListServices = async (token, clientCustomerId,  page, size) => {
  try {
    const response = await apiService(`/activity-logs/logs/client-customer/${clientCustomerId}?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch activity data. Please try again.');
  }
};
